import { useEffect } from 'react';
import { PermissionDenied, PermissionEnum, IconLoader } from '@ui/src';
import { useAppSelector } from '@store';
import GeographicalList from './geographical-list';

import cn from './geographical.module.css';

const GeographicalListHOC = () => {
  const { activePermissions } = useAppSelector(
    (state) => state.amlDictionaries,
  );

  useEffect(() => {
    let title = 'Geographical risk';

    const companyName = localStorage.getItem('companyName');

    if (companyName) {
      title = `${title} | ${companyName}`;
    }

    document.title = title;
  }, []);

  let content = (
    <div className={cn.geographicalRiskLoader}>
      <IconLoader />
    </div>
  );

  if (activePermissions) {
    if (
      !activePermissions.includes(PermissionEnum.SECTION_AML_KYC) ||
      !activePermissions.includes(PermissionEnum.AML_GEO_LIST)
    ) {
      content = <PermissionDenied />;
    } else {
      content = (
        <div className={cn.geographicalRisk}>
          <div className={cn.geographicalRiskTop}>
            <div className={cn.geographicalRiskTitle}>Geographical risk</div>
          </div>
          <GeographicalList />
        </div>
      );
    }
  }

  return content;
};

export default GeographicalListHOC;
